// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".is-selected[data-v-751bd304]{border:4px solid #6188e7}.selectable-image[data-v-751bd304]:hover{border:4px solid #edf2fc;cursor:pointer}.selectable-image-disabled[data-v-751bd304]:hover{pointer-events:none;cursor:not-allowed}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
